var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),_c('p',[_vm._v(_vm._s(_vm.content.heading))]),_vm._l((_vm.areas),function(area,i){return _c('EditableArea',{key:'editable-area__' + i,attrs:{"content":area,"parent-template-id":_vm.pageTemplateId}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }